<template>
  <div>
    <div>
      <router-view></router-view>
    </div>
    <go-to-top/>
  </div>
</template>

<script>
import Vue from "vue";
import GoToTop from "@/components/mock/base/pageTop";
Vue.component("go-to-top", GoToTop);

export default {
  name: "shippngIndex",
  data() {
    return {
    };
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/holter/shipping/index.vue